import AppBar from '@mui/material/AppBar';
import Badge from '@mui/material/Badge';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Tooltip from '@mui/material/Tooltip';
import copy from 'copy-to-clipboard';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { loadForms, loadServicers } from '../../actions/dataActions';
import { confirmAction, showError, showMessage } from '../../actions/uiActions';
import AccountsApi from '../../api/accounts';
import Auth from '../../api/auth';
import FormsApi from '../../api/forms';
import InboxApi from '../../api/inbox';
import ServicersApi from '../../api/servicers';
import UsersApi from '../../api/users';
import Forgiveness from '../../components/Forgiveness';
import Forms from '../../components/Forms';
import Loading from '../../components/Loading';
import Loans from '../../components/Loans';
import RecertificationNotice from '../../components/RecertificationNotice';
import ResetUserPassword from '../../components/ResetUserPassword';
import StrategyView from '../../components/StrategyView';
import TerminationNotice from '../../components/TerminationNotice';
import UserActions from '../../components/UserActions';
import UserDates from '../../components/UserDates';
import UserInbox from '../../components/UserInbox';
import UserInfo from '../../components/UserInfo';
import UserNotes from '../../components/UserNotes';
import archiveOption from '../../components/Users/archiveOptions.json';
import Archive from '../../forms/Archive';
import CustomEmail from '../../forms/CustomEmail';
import AnalysisTools from '../../utils/AnalysisTools';
import Formatter from '../../utils/Formatter';
import { withRouter } from '../../utils/withRouter';
import { format } from 'date-fns';

class User extends Component
{
  state = {
    account: null,
    loan: null,
    strategy: false,
    currentTab: 0,
    unreadMessages: 0,
    scheduling: false,
    source: '',
    reset: false,
    email: false,
    forcingConfirm: false,
    showArchive: false
  };
  componentDidMount()
  {
    if (this.props.location.search)
    {
      const origin = this.props.location.search.match(/source=(.+)$/);
      if ((origin || []).length === 2) this.setState({ source: origin[1] });
    }
    this.getUserAccount()
    this.getUserMSDs();
    if (this.props.servicers.length === 0)
    {
      ServicersApi.list()
        .then(
          servicers => this.props.loadServicers(servicers),
          error => console.log(error)
        )
        .catch(error => console.log(error));
    }
    if (this.props.forms.length === 0)
    {
      FormsApi.list()
        .then(
          forms => this.props.loadForms(forms),
          error => console.log(error)
        )
        .catch(error => console.log(error));
    }
  }
  getUserMSDs = async () =>
  {
    try
    {
      const allUserMSDs = await UsersApi.getUserMSDs(this.props.match.params.id);
      this.setState({ allUserMSDs });
    } catch (error)
    {
      this.props.showError(error);
    }
  }
  close = () =>
  {
    if (this.state.loan) this.setState({ loan: null });
    else if (this.state.strategy) this.setState({ strategy: false });
    else if (this.state.source) this.props.history.push(`${this.state.source}`);
    else this.props.history.goBack();
  };
  forceConfirm = () =>
  {
    this.props.confirmAction(
      'You are going to request the user to review, update and confirm the Personal Information, Finances, Employment and re upload the MyStudentData.txt file. The user will be blocked from accessing any other sections of the App until the information has been confirmed. Do you want to proceed?',
      () =>
      {
        this.setState(
          {
            forcingConfirm: true
          },
          async () =>
          {
            try
            {
              await UsersApi.forceConfirmInformation(this.state.account._id);
              this.props.showMessage(
                'En email requesting to confirm the information has been sent to the user.'
              );
            } catch (error)
            {
              this.props.showError();
            }
            this.setState({
              forceConfirm: false,
              account: {
                ...this.state.account,
                confirmations: {
                  ...this.state.account.confirmations,
                  personal_info: 0
                }
              }
            });
          }
        );
      }
    );
  };
  requestMSD = () =>
  {
    this.props.confirmAction(
      'You are going to request the user to upload their MyStudentData.txt file. The user will be blocked from accessing any other sections of the App until the MSD has been uploaded. Do you want to proceed?',
      async () =>
      {
        try
        {
          await UsersApi.requestMSDInformation(this.state.account._id);
          this.props.showMessage(
            'An email requesting to upload new MSD File has been sent to the user.'
          );
        } catch (error)
        {
          this.props.showError();
        }
      }
    );
  };
  onRecertificationDateUpdated = details =>
  {
    let { account } = this.state;
    if (details.type === 'IDR')
    {
      account.idr_recertification = {
        date: details.date,
        servier: details.servicer
      };
    } else if (details.type === 'PSLF')
    {
      if (details.deleted)
      {
        account.pslf_recertifications = null;
      } else
      {
        account.pslf_recertifications = {
          ...account.pslf_recertifications,
          recertificationDate: details.date
        };
      }
    } else
    {
      account.tlf_recertification = {
        tlfForgivenessDate: details.date,
        employer: {
          employer_name: details.employer_name
        }
      };
    }
    this.setState({ account });
  };
  getUserAccount = () =>
  {
    AccountsApi.get(this.props.match.params.id)
      .then(account =>
      {
        this.setState({
          account: {
            ...account,
            myStudentData: account.msd
              ? Formatter.normalizeMyStudentData(account.msd.details)
              : {}
          }
        });
        InboxApi.unreadMessagesCount(this.props.match.params.id)
          .then(count => this.setState({ unreadMessages: count }))
          .catch(error => { });
      })
      .catch(error =>
      {
        this.props.showError();
        this.props.history.goBack();
      });
  }

  handleArchive = async (e) =>
  {
    e.preventDefault();
    if ((this.state.account || {}).isArchived)
    {
      try
      {
        this.props.confirmAction('Are you sure you want to unarchive this user?', async () =>
        {
          await AccountsApi.unArchiveUser(this.state.account._id);
          this.getUserAccount()
          this.props.showMessage('Account successfully unarchive');
        });
      } catch (error)
      {
        this.props.showMessage(error);
      }
    } else
    {
      this.setState({ showArchive: true });
    }
  }

  determineArchiveReason = (reason) =>
  {
    const archives = archiveOption.filter((archive) => archive.value === reason);
    return archives[0].label
  }

  markUserAsCantHelp = () =>
  {
    this.props.confirmAction(
      "You are going to send a message to the user notifying that no strategy was found, this will label the user as lost and will remove it from the pipeline. Do you want to proceed?",
      async () =>
      {
        try
        {
          await UsersApi.discard(this.state.account._id);
          this.props.showMessage("The user has been notified.");
        } catch (error)
        {
          this.props.showError(error.message);
        }
      }, "Confirm Action", "Proceed", "Cancel")
  }

  createImpersonation = async () =>
  {
    try
    {
      const url = await UsersApi.impersonate(this.state.account._id);
      copy(url);
      this.props.showMessage('Impersonation link copied to clipboard. Paste it in your incognito browser');
    } catch (error)
    {
      this.props.showError(error);
    }
  }

  canResetAndImpersonate = () =>
  {
    const { account } = this.state;
    if (account.isArchived)
    {
      return false;
    }
    if ((account.status === 'lost' || account.loanType === "private") && account.employer.services.slra)
    {
      return true;
    }
    if (account.membership)
    {
      return true;
    }
    return false;
  }

  canShowResetPassword = () => {
    if (this.state.account.hasSso) return false;
    return this.canResetAndImpersonate();
  }

  render()
  {
    const importantDates = this.state.account
      ? AnalysisTools.countUpcomingDates(this.state.account)
      : 0;
    return (
      <section className="wide animated fadeIn">
        {this.state.email && (
          <CustomEmail
            user={this.props.match.params.id}
            onClose={() => this.setState({ email: false })}
          />
        )}
        {this.state.account && (
          <header>
            <h1>
              Users &gt;
              {this.state.account.name ||
                `${this.state.account.firstname} ${this.state.account.lastname}`}
              {this.state.loan &&
                ` > ${this.state.loan.loan_type.toUpperCase()} LOANS`}
              {this.state.strategy && ` > ANALYSIS`}
            </h1>
            <div className="actions">
              <Tooltip title="Request the User to Upload Latest MSD File Information">
                <button onClick={this.requestMSD}>Request MSD File</button>
              </Tooltip>
              {!!this.state.account.confirmations?.personal_info &&
                (this.state.forceConfirm ? (
                  'Sending request...'
                ) : (
                  <Tooltip title="Request the User to Confirm Personal, Finances and Employment Information">
                    <button onClick={this.forceConfirm}>
                      Request to Confirm Information
                    </button>
                  </Tooltip>
                ))}
              {this.canShowResetPassword() && (
                <Tooltip title="Reset Password">
                  <button
                    onClick={() =>
                    {
                      this.setState({ reset: true });
                    }}
                  >
                    Reset Password
                  </button>
                </Tooltip>
              )}
              <Tooltip title="Notify the user he currently has the best plan">
                <button onClick={this.markUserAsCantHelp}>
                  Can't Find Strategy
                </button>
              </Tooltip>

              <Tooltip title="Send an Email to this user">
                <button onClick={() => this.setState({ email: true })}>
                  Send Email
                </button>
              </Tooltip>
              {
                this.canResetAndImpersonate() && (
                  <Tooltip title="Impersonate account">
                    <button onClick={this.createImpersonation}>
                      <span>Impersonate</span>
                    </button>
                  </Tooltip>
                )
              }
              <Tooltip title="Archive this user account">
                <button onClick={this.handleArchive}>
                  <span className='danger'>{(this.state.account || {}).isArchived ? 'Unarchive' : 'Archive'}</span>
                </button>
              </Tooltip>
              <Tooltip title="Delete this user account">
                <button
                  onClick={() =>
                  {
                    this.props.confirmAction(
                      'You are going to permanently delete this user account and all the information associated to it, including any documents. This process is irreversible and all the information will be completely lost. Do you want to proceed and delete the user anyway?',
                      () =>
                        this.props.confirmAction(
                          'Please confirm that you want to permanently delete the user account, and all its associated files, analysis, and personal information.',
                          () =>
                            this.setState({ deleting: true }, async () =>
                            {
                              try
                              {
                                await AccountsApi.delete(this.state.account._id);
                                this.props.showMessage('The user account has been deleted.');
                                this.props.history.push('/');
                              } catch (error)
                              {
                                this.setState({ deleting: false }, this.props.showError(error))
                              }
                            }
                            ),
                          'Please Confirm',
                          'Delete User Account Permanently',
                          'Cancel'
                        ),
                      'Warning!!!'
                    )
                  }}
                >
                  <span className='danger'>Delete</span>
                </button>
              </Tooltip>
              <button onClick={this.close}>Close</button>
            </div>
          </header>
        )}
        {(this.state.account || {}).isArchived && (
          <div className="alert alert-warning">
            <center><b>This account has been archived</b></center> <br />
            <b>Why Archived</b>: {this.determineArchiveReason(this.state.account.isArchived.reason_key)} <br />
            <b>Note</b>: {this.state.account.isArchived.reason_description} <br />
            <b>When</b>: {this.state.account.isArchived.archivedDate ? format(new Date(this.state.account.isArchived.archivedDate * 1000), 'MM-dd-yyyy HH:mm') : 'N/A'}
          </div>
        )}
        {this.state.account &&
          AnalysisTools.hasRecertificationPending(this.state.account) && (
            <RecertificationNotice
              account={this.state.account}
              onReminder={() =>
              {
                this.setState({
                  account: {
                    ...this.state.account,
                    recertificationNotice: moment().format('X')
                  }
                });
              }}
            />
          )}

        {this.state.account?.terminatedDate && !this.state.account?.isArchived && <TerminationNotice account={this.state.account} callBack={this.getUserAccount} />}

        {(!this.state.account ||
          this.state.deleting ||
          this.state.scheduling) && (
            <Loading
              message={
                this.state.deleting
                  ? 'Deleting user account...'
                  : this.state.scheduling
                    ? 'Sending email to user...'
                    : 'Loading user information...'
              }
            />
          )}
        {this.state.account &&
          !this.state.deleting &&
          !this.state.loan &&
          !this.state.strategy && (
            <Paper>
              <AppBar position="static" color="default">
                <Tabs
                  value={this.state.currentTab}
                  onChange={(e, newValue) =>
                    this.setState({ currentTab: newValue }, () =>
                      this.props.history.push(
                        `/users/${this.props.match.params.id}/${this.state.currentTab}?source=${this.state.source}`
                      )
                    )
                  }
                  indicatorColor="primary"
                  textColor="primary"
                  centered
                >
                  <Tab label="General Information" />
                  {/*<Tab label="Loans" />*/}
                  <Tab label="Strategy" />
                  {/* <Tab label="Analysis" />*/}
                  <Tab label="Forms" />
                  <Tab
                    label={
                      this.state.unreadMessages > 0 ? (
                        <Badge
                          badgeContent={this.state.unreadMessages}
                          color="primary"
                        >
                          <span className="margin-rigth10">Inbox</span>
                        </Badge>
                      ) : (
                        <span>Inbox</span>
                      )
                    }
                  />
                  {/* <Tab label="Status" /> */}
                  <Tab
                    label={
                      importantDates > 0 ? (
                        <Badge
                          badgeContent={
                            <span className="little-badge">
                              {importantDates}
                            </span>
                          }
                          color="secondary"
                        >
                          Important Dates
                        </Badge>
                      ) : (
                        'Important Dates'
                      )
                    }
                  />
                  {Auth.account.super && <Tab label="Action" />}
                  <Tab label="Forgiveness/Default" />
                </Tabs>
              </AppBar>
              <div className="line-break"></div>

              {this.state.currentTab == 0 && (
                <UserInfo
                  onLoan={loan => this.setState({ loan })}
                  msds={this.state.allUserMSDs}
                  getMsds={this.getUserMSDs}
                  onLoanUpdated={myStudentData =>
                    this.setState({
                      account: {
                        ...this.state.account,
                        msd: {
                          ...this.state.account.msd,
                          details: myStudentData
                        }
                      }
                    })
                  }
                  onMyStudentDataUploaded={msd =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        msd
                      }
                    });
                  }}
                  onAnalysisUpdated={analysis =>
                    this.setState({
                      account: {
                        ...this.state.account,
                        analysis
                      }
                    })
                  }
                  id={this.props.match.params.id}
                  onEmploymentInfoUpdated={employmentInfo =>
                    this.setState({
                      account: {
                        ...this.state.account,
                        employment: {
                          ...this.state.account.employment,
                          ...employmentInfo
                        }
                      }
                    })
                  }
                  onFinancialInfoUpdated={financialInfo =>
                    this.setState({
                      account: {
                        ...this.state.account,
                        finances: {
                          ...this.state.account.finances,
                          ...financialInfo
                        },
                      }
                    })
                  }
                  onPersonalInfoUpdated={personalInfo =>
                    this.setState({
                      account: {
                        ...this.state.account,
                        ...personalInfo,
                        confirmations: {
                          ...this.state.account.confirmations,
                          personal_info: moment().unix()
                        }
                      }
                    })
                  }
                  account={this.state.account}
                  onAnalysis={() => this.setState({ currentTab: 1 })}
                />
              )}
              {/*this.state.currentTab==1&&<UserLoans onLoan={(loan)=>this.setState({loan})} account={this.state.account} />*/}
              {this.state.currentTab == 1 && (
                <StrategyView
                  onForms={() => this.setState({ currentTab: 2 })}
                  onAnalysisUpdated={(analysis) =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        analysis,
                      }
                    });
                  }}
                  myStudentData={this.state.account.loanType === 'private' || !this.state.account.msd ? null : this.state.account.msd.details}
                  id={this.props.match.params.id}
                  msds={this.state.allUserMSDs}
                  onAccountUpdated={(accountUpdates) =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        ...accountUpdates
                      }
                    });
                    this.getUserAccount()
                  }}
                  account={this.state.account}
                  analysis={this.state.account.analysis}
                  onClose={() => this.setState({ strategy: false })}
                />
              )}
              {this.state.currentTab == 2 && (
                <Forms
                  updateAccount={updates =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        ...updates
                      }
                    })
                    this.getUserAccount()
                  }}
                  onFormSubmitted={(form, live = false) =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        forms: this.state.account.forms.map(existingForm =>
                        {
                          if (existingForm.id == form.id)
                          {
                            existingForm.submitted = true;
                            existingForm.live = live;
                          }
                          return existingForm;
                        })
                      }
                    })
                    this.getUserAccount()
                  }}
                  onFormStatus={(formId, status) =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        forms: this.state.account.forms.map(form =>
                        {
                          if (form.id == formId)
                          {
                            form.status = status;
                          }
                          return form;
                        })
                      }
                    })
                    this.getUserAccount()
                  }}
                  onEmployer={(formId, employer) =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        forms: this.state.account.forms.map(form =>
                        {
                          if (form.id == formId)
                          {
                            form.employer = employer;
                          }
                          return form;
                        })
                      }
                    })
                    this.getUserAccount()
                  }}
                  onApprove={() =>
                  {
                    this.setState({
                      account: { ...this.state.account, status: 'user' }
                    })
                    this.getUserAccount()
                  }}
                  onFormDeleted={form =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        forms: this.state.account.forms.filter(
                          existingForm => existingForm.id != form.id
                        )
                      }
                    })
                    this.getUserAccount()
                  }}
                  onFormAssigned={form =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                      }
                    })
                    this.getUserAccount()
                  }}
                  onFormCompleted={(form, servicer) =>
                  {
                    this.setState({
                      account: {
                        ...this.state.account,
                        forms: this.state.account.forms.map(existingForm =>
                        {
                          if (existingForm.id == form.id)
                          {
                            existingForm.completed = true;
                            existingForm.live = false;
                            existingForm.submitted = false;
                          }
                          return existingForm;
                        })
                      }
                    });
                    this.getUserAccount()
                  }}
                  id={this.props.match.params.id}
                  myStudentData={this.state.account.loanType === 'private' || !this.state.account.msd ? null : this.state.account.msd.details}
                  forms={this.state.account.forms || []}
                  analysis={this.state.account.analysis}
                  account={this.state.account}
                />
              )}
              {this.state.currentTab === 3 && (
                <UserInbox
                  messageRead={() =>
                    this.setState({
                      unreadMessages: this.state.unreadMessages - 1
                    })
                  }
                  id={this.props.match.params.id}
                  account={this.state.account}
                />
              )}
              {this.state.currentTab === 4 && (
                <UserDates
                  onFormAssigned={form =>
                  {
                    this.setState(
                      {
                        account: {
                          ...this.state.account,
                          forms: [...this.state.account.forms, form]
                        }
                      },
                      () =>
                      {
                        this.props.confirmAction(
                          'The user information might have changed since the last time the form you have just re-assigned was signed. Do you want to request the user to re-confirm his/her information?',
                          this.forceConfirm
                        );
                      }
                    );
                  }}
                  onRecertificationDateUpdated={details =>
                    this.onRecertificationDateUpdated(details)
                  }
                  account={this.state.account}
                />
              )}
              {Auth.account.super &&
                this.state.currentTab === 5 && (
                  <UserActions
                    onActivated={() => this.props.history.push('/')}
                    account={this.state.account}
                  />
                )}
              {this.state.currentTab === 6 && (
                <Forgiveness account={this.state.account} />
              )}
              <div className="line-break"></div>
            </Paper>
          )}
        {this.state.loan && (
          <Loans
            id={this.props.match.params.id}
            onLoanUpdated={myStudentData =>
              this.setState({
                account: { ...this.state.account, myStudentData }
              })
            }
            onAnalysisUpdated={analysis =>
              this.setState({ account: { ...this.state.account, analysis } })
            }
            myStudentData={this.state.account.msd.details}
            loan={this.state.loan}
            onClose={() => this.setState({ loan: null })}
          />
        )}
        {this.state.reset && (
          <ResetUserPassword
            id={this.state.account._id}
            onClose={() => this.setState({ reset: false })}
          />
        )}
        <UserNotes account={this.state.account} />
        {/* <KnowledgeBaseComponent
          employer={(this.state.account || {}).employer}
          title="FAQ"
          showLeft={true}
          closeOnClickOutside={false}
          classNamePrefix={'faq'}
          directLinks={true}
          loadingCmp={<CircularProgress size={24} />}
        /> */}
        {this.state.showArchive && <Archive onClose={() => this.setState({ showArchive: false })} userId={this.state.account._id} onSuccess={this.getUserAccount} />}
      </section>
    );
  }
}
const mapStateToProps = state =>
{
  return {
    servicers: state.data.servicers,
    forms: state.data.forms
  };
};
User.propTypes = {
  showError: PropTypes.func,
  showMessage: PropTypes.func
};
export default withRouter(connect(mapStateToProps, {
  showError,
  showMessage,
  confirmAction,
  loadServicers,
  loadForms
})(User));
